import { useMeQuery } from '@platform/state/api';

/** Чи має поточний користувач можливість `export` у воркспейсі (кнопки експорту CSV показуються лише з нею). */
export function useCanExport(ws: string): boolean {
  const { data: me } = useMeQuery();
  return Boolean(me?.workspaces.find((w) => w.id === ws)?.myCapabilities.includes('export'));
}
